import React from "react";

import {
  TeaserCard,
  CardContent,
  CardTitle,
  useThemeProps,
} from "../../wsui/base";

export default function DefaultHit(props) {
  props = useThemeProps({ props, name: "AlgoliaDefaultHit" });
  props = useThemeProps({ props, name: "AlgoliaHit" });
  let {
    hit,
    horizontalContentMaxWidth = "100%",
    // eslint-disable-next-line no-unused-vars
    hitsOwnerState,
    ...restProps
  } = props;

  const { title, url } = hit;

  return (
    <TeaserCard
      link={{ url }}
      title={title}
      as="li"
      horizontalContentMaxWidth={horizontalContentMaxWidth}
      {...restProps}
    >
      <CardContent>
        <CardTitle />
      </CardContent>
    </TeaserCard>
  );
}
